import request from "@/utils/request";

// 获取币种列表
export const getCurrencyCountryList = async (params) =>
  request({ url: "/drp-base/currencyCountry/list", method: "get", params });
